import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, finalize } from 'rxjs';

import { PaginatedList, QualityCheckPicture, WorkPackage, WorkPackageIncludeOptions } from '@shared/models';

import { BaseService } from '../base.service';
import { httpParams } from '../http-params.builder';
import { LoadersService } from '../loaders.service';

@Injectable({ providedIn: 'root' })
export class WorkPackagesService extends BaseService {
  constructor(
    private http: HttpClient,
    private loadersService: LoadersService
  ) {
    super();
  }

  getAll(loader: string, projectId: string, options?: WorkPackageIncludeOptions): Observable<WorkPackage[]> {
    this.loadersService.show(loader);

    return this.http
      .get<WorkPackage[]>(`${this.baseUrl}/work-packages`, {
        params: httpParams().set('projectId', projectId).json('options', options).build(),
      })
      .pipe(finalize(() => this.loadersService.hide(loader)));
  }

  getQualityCheckPictures(
    loader: string,
    workPackageId: string,
    pageIndex: number,
    pageSize: number
  ): Observable<PaginatedList<QualityCheckPicture>> {
    this.loadersService.show(loader);

    return this.http
      .get<PaginatedList<QualityCheckPicture>>(
        `${this.baseUrl}/work-packages/${workPackageId}/quality-check-pictures`,
        {
          params: httpParams().paging(pageIndex, pageSize).build(),
        }
      )
      .pipe(finalize(() => this.loadersService.hide(loader)));
  }
}
